var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cta" },
    [
      !_vm.$store.state.isRoomAvailabilityLoaded
        ? _c("div", { staticClass: "price" }, [_vm._v("...")])
        : _vm.isAvailable
        ? _c(
            "div",
            { staticClass: "price" },
            [
              _vm.averagePricePreferred === 0
                ? _c("span", { staticClass: "rate" }, [
                    _vm._v(
                      "\n      $" +
                        _vm._s(Math.round(_vm.averagePriceStandardToDisplay)) +
                        "\n      "
                    ),
                    _c("span", { staticClass: "less-emphasis" }, [
                      _vm._v("avg/night"),
                    ]),
                  ])
                : _c("span", { staticClass: "rate" }, [
                    _c("span", { staticClass: "less-emphasis" }, [
                      _vm._v("Standard:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "strike" }, [
                      _vm._v(
                        "$" +
                          _vm._s(Math.round(_vm.averagePriceStandardToDisplay))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "less-emphasis" }, [
                      _vm._v("avg/night"),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "rate",
                        attrs: { "data-tooltip": _vm.preferredTooltipCopy },
                      },
                      [
                        _c("span", { staticClass: "less-emphasis" }, [
                          _vm._v("Members:"),
                        ]),
                        _vm._v(
                          " $ " +
                            _vm._s(
                              Math.round(_vm.averagePricePreferredToDisplay)
                            ) +
                            "\n      "
                        ),
                        _c("span", { staticClass: "less-emphasis" }, [
                          _vm._v("avg/night"),
                        ]),
                      ]
                    ),
                  ]),
              _vm._v(" "),
              _vm.roomAvailabilityData.ROOM_TYPES.length
                ? [
                    !_vm.showRateDetails
                      ? [
                          _vm.addResortFeeToRoomRate
                            ? _c(
                                "div",
                                { staticClass: "less-emphasis rate-subtotal" },
                                [
                                  _c("span", { staticClass: "less-emphasis" }, [
                                    _vm._v(
                                      "\n            Room Rate $" +
                                        _vm._s(
                                          _vm.formatAsDollarAmount(
                                            _vm.averageSubtotal
                                          )
                                        ) +
                                        " avg/night\n          "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.addResortFeeToRoomRate
                            ? _c(
                                "div",
                                {
                                  staticClass: "less-emphasis rate-resort-fee",
                                },
                                [
                                  _c("span", { staticClass: "less-emphasis" }, [
                                    _vm._v(
                                      "\n            Resort Fee $" +
                                        _vm._s(
                                          _vm.formatAsDollarAmount(
                                            _vm.averageResortFee
                                          )
                                        ) +
                                        " /night\n          "
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "less-emphasis rate-resort-fee",
                                },
                                [
                                  _c("span", { staticClass: "less-emphasis" }, [
                                    _vm._v(
                                      "\n            Plus Resort Fee of $" +
                                        _vm._s(
                                          _vm.formatAsDollarAmount(
                                            _vm.averageResortFee
                                          )
                                        ) +
                                        " /night\n          "
                                    ),
                                  ]),
                                ]
                              ),
                        ]
                      : _c(
                          "table",
                          {
                            staticClass:
                              "hotel_room--cta_rate_table less-emphasis",
                            attrs: {
                              "aria-label":
                                "Rate information for selected stay",
                            },
                          },
                          [
                            _c(
                              "tr",
                              { staticClass: "less-emphasis rate-subtotal" },
                              [
                                _c("td", [_vm._v("Room Rate")]),
                                _vm._v(" "),
                                _vm.showRateDetailTotals
                                  ? _c("td", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.formatAsDollarAmount(
                                              _vm.subtotal,
                                              false
                                            )
                                          )
                                      ),
                                    ])
                                  : _c("td", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.formatAsDollarAmount(
                                              _vm.averageSubtotal,
                                              false
                                            )
                                          ) +
                                          " avg/night"
                                      ),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.showRateDetails
                              ? [
                                  _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "less-emphasis rate-resort-fee",
                                    },
                                    [
                                      _c("td", [_vm._v("Resort Fee")]),
                                      _vm._v(" "),
                                      _vm.showRateDetailTotals
                                        ? _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageResortFee
                                                  )
                                                ) +
                                                " /night"
                                            ),
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageResortFee
                                                  )
                                                ) +
                                                " /night"
                                            ),
                                          ]),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showRateDetails
                              ? [
                                  _c(
                                    "tr",
                                    { staticClass: "less-emphasis rate-tax" },
                                    [
                                      _c("td", [_vm._v("Room Tax")]),
                                      _vm._v(" "),
                                      _vm.showRateDetailTotals
                                        ? _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.totalRoomTax,
                                                    false
                                                  )
                                                )
                                            ),
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageRoomTax,
                                                    false
                                                  )
                                                ) +
                                                " avg/night"
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "less-emphasis rate-resort-fee",
                                    },
                                    [
                                      _c("td", [_vm._v("Resort Fee")]),
                                      _vm._v(" "),
                                      _vm.showRateDetailTotals
                                        ? _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.totalResortFee,
                                                    false
                                                  )
                                                )
                                            ),
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageResortFee,
                                                    false
                                                  )
                                                ) +
                                                " /night"
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "less-emphasis rate-resort-fee-tax",
                                    },
                                    [
                                      _c("td", [_vm._v("Resort Fee Tax")]),
                                      _vm._v(" "),
                                      _vm.showRateDetailTotals
                                        ? _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.totalResortFeeTax,
                                                    false
                                                  )
                                                )
                                            ),
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageResortFeeTax,
                                                    false
                                                  )
                                                ) +
                                                " /night"
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "less-emphasis rate-tourism-surcharge",
                                    },
                                    [
                                      _c("td", [_vm._v("Tourism Surcharge")]),
                                      _vm._v(" "),
                                      _vm.showRateDetailTotals
                                        ? _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.totalTourismSurcharge,
                                                    false
                                                  )
                                                )
                                            ),
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageTourismSurcharge,
                                                    false
                                                  )
                                                ) +
                                                " /night"
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "tr",
                                    { staticClass: "less-emphasis rate-total" },
                                    [
                                      _c("td", [_vm._v("Total")]),
                                      _vm._v(" "),
                                      _vm.showRateDetailTotals
                                        ? _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.total,
                                                    false
                                                  )
                                                )
                                            ),
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formatAsDollarAmount(
                                                    _vm.averageTotal,
                                                    false
                                                  )
                                                ) +
                                                " avg/night"
                                            ),
                                          ]),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.showRateDetails
                ? _c(
                    "a",
                    {
                      staticClass: "info",
                      attrs: { title: "Click to view rate details", href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.openRateDialog.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("svg", [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#symbol_info",
                          },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : [
            _vm.minStayDays > 0
              ? _c("div", { staticClass: "price" }, [
                  _c("p", { staticClass: "quote" }, [
                    _vm._v(
                      "Minimum stay length is " +
                        _vm._s(_vm.minStayDays) +
                        " night" +
                        _vm._s(1 < _vm.minStayDays ? "s" : "") +
                        "."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "quote" }, [
                    _vm._v(
                      "You have selected a " +
                        _vm._s(_vm.$store.state.stayLength) +
                        " night stay."
                    ),
                  ]),
                ])
              : _vm.roomAdjacentDates.length
              ? _c(
                  "div",
                  { staticClass: "price" },
                  [
                    _c("p", { staticClass: "quote" }, [
                      _vm._v("Selected dates unavailable. Check in on:"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.roomAdjacentDates, function (adjacentDate) {
                      return [
                        adjacentDate.hasOwnProperty("AHEAD") &&
                        adjacentDate.AHEAD.hasOwnProperty("ADJACENT_DAY_SHIFT")
                          ? _c(
                              "a",
                              {
                                staticClass: "quote quote-ahead",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.adjacentDateClickHandler(
                                      adjacentDate.AHEAD.ADJACENT_DAY_SHIFT
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(adjacentDate.AHEAD.CHECKIN_DATE) +
                                    " for " +
                                    _vm._s(
                                      _vm.getAdjacentDatePrice(
                                        adjacentDate.AHEAD
                                      )
                                    ) +
                                    " avg/night*\n        "
                                ),
                              ]
                            )
                          : adjacentDate.hasOwnProperty("BEHIND") &&
                            adjacentDate.BEHIND.hasOwnProperty(
                              "ADJACENT_DAY_SHIFT"
                            )
                          ? _c(
                              "a",
                              {
                                staticClass: "quote behind",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.adjacentDateClickHandler(
                                      adjacentDate.BEHIND.ADJACENT_DAY_SHIFT
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(adjacentDate.BEHIND.CHECKIN_DATE) +
                                    " for " +
                                    _vm._s(
                                      _vm.getAdjacentDatePrice(
                                        adjacentDate.BEHIND
                                      )
                                    ) +
                                    " avg/night*\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              : _c("div", { staticClass: "price" }, [
                  _vm._v("\n      Sold Out\n\n      "),
                  _vm._m(0),
                ]),
          ],
      _vm._v(" "),
      _c("div", { staticClass: "cta--dates" }, [
        _c("p", [
          _c("span", { staticClass: "less-emphasis" }, [_vm._v("Check In")]),
          _vm._v(" "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.checkInDateFormatted) },
          }),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "less-emphasis" }, [_vm._v("Check Out")]),
          _vm._v(" "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.checkOutDateFormatted) },
          }),
        ]),
      ]),
      _vm._v(" "),
      !_vm.$store.state.isRoomAvailabilityLoaded
        ? _c(
            "a",
            { staticClass: "btn get-rates btn-disabled", attrs: { href: "#" } },
            [_vm._v("Loading Rates")]
          )
        : _vm.isAvailable
        ? _c(
            "a",
            {
              staticClass: "btn get-rates",
              attrs: { href: _vm.bookNowLink },
              on: { click: _vm.getRatesClickHandler },
            },
            [_vm._v("Book Now")]
          )
        : _vm.minStayDays > 0
        ? _c(
            "a",
            {
              staticClass: "btn",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.updateCheckOutDateForMinNights.apply(
                    null,
                    arguments
                  )
                },
              },
            },
            [_vm._v("Make\n    " + _vm._s(_vm.minStayDays) + " Night Stay")]
          )
        : _c(
            "a",
            { staticClass: "btn get-rates btn-disabled", attrs: { href: "#" } },
            [_vm._v("Not Available")]
          ),
      _vm._v(" "),
      _vm.showLearnMoreButton
        ? _c(
            "a",
            {
              staticClass: "btn btn-dark",
              attrs: {
                href: _vm.page.URL,
                title: "Learn more about the " + _vm.page.TITLE,
              },
            },
            [_vm._v("Learn\n    More")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "less-emphasis rate-resort-fee" }, [
      _c("span", { staticClass: "less-emphasis" }, [_vm._v(" ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }